import { variant } from 'styled-system'

const counterVariant = variant({
  prop: 'size',
  variants: {
    small: {
      padding: '4px',
      width: '80px',
    },
    large: {
      padding: '8px 4px',
      width: '136px',
    },
  },
})

export { counterVariant }
